import AmioHttpService from '@/services/amio/amio-http.service'

class UtilsService extends AmioHttpService {
  async previewXmlFeed(url, itemTag) {
    try {
      const params = { url }
      if (itemTag) {
        params.itemTag = itemTag
      }
      const response = await this.requestGet('/utils/preview-xml-feed', { params })
      return adapt(response.data)
    } catch (err) {
      throw this.handleError(err)
    }
  }
}

function adapt(response) {
  const adaptedResponse = {
    itemTag: response.item_tag,
    itemTagData: response.item_tag_data
  }

  return adaptedResponse
}

export default new UtilsService()
